import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";
/**
 * formField property
 * type(string),name(string),label(string) is required
 * xs(int),errorMsg(string),required(bool),maxLength(int),tabIndex(int),disabled(bool) is optional
 *
 * set xs only when need change input field width
 * set errorMsg only when required is true
 * set disabled only when not allow to input
 * set tabIndex when need control tab order
 * set edit when want disabled input field
 *
 */
const formField = {
  coNumber: {
    type: "text", //required
    name: "coNumber", //required
    label: "CO No", //required
    errorMsg: "CO No is required", //optional
    maxLength: 20, //optional
    disabled: true,
  },
  vendorCode: {
    type: "select",
    name: "vendorCode",
    label: "Vendor Code",
    errorMsg: "Vendor Code is required.",
    required: true,
    editable: false,
  },
  coDate: {
    type: "date",
    name: "coDate",
    label: "CO Date",
    required:true,
    errorMsg: "CO Date is required",
  },
  dateExpected: {
    type: "date",
    name: "dateExpected",
    label: "Expected Date",
  },
  consigneeCode: {
    type: "select",
    name: "consigneeCode",
    label: "Consignee Code",
  },
  cgCompany: {
    type: "text",
    name: "cgCompany",
    label: "Consignee Name",
    required: true,
    errorMsg: "Consignee Name is required",
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    required: true,
    disabled: true,
    errorMsg: "Customer Code is required",
    // errorMsg: "Vendor Code is required",
    // xs: 6,
    // required: true,
    // edit:true
  },
  cgAddress1: { type: "text", name: "cgAddress1", label: "Address1", maxLength: 200 },
  cgAddress2: { type: "text", name: "cgAddress2", label: "Address2", maxLength: 200 },
  consigneeCompany: { type: "text", name: "consigneeCompany", label: "Company", maxLength: 100 },
  cgPostcode: { type: "text", name: "cgPostcode", label: "Postcode", maxLength: 10 },
  cgCity: { type: "text", name: "cgCity", label: "City", maxLength: 100 },
  cgState: { type: "text", name: "cgState", label: "State", maxLength: 100 },
  cgCountry: { type: "text", name: "cgCountry", label: "Country", maxLength: 100 },
  cgPhoneNo: { type: "text", name: "cgPhoneNo", label: "Tel No", maxLength: 20 },
  cgFaxNo: { type: "text", name: "cgFaxNo", label: "Fax No", maxLength: 20 },
  reference: { type: "text", name: "reference", label: "Reference", maxLength: 100 },
  truckNo: { type: "text", name: "truckNo", label: "TruckNo", maxLength: 20 },
  remark: { type: "text", name: "remark", label: "Remark", maxLength: 300 },
  status: { type: "text", name: "status", label: "Status", disabled: true },
  extCONumber: { type: "text", name: "extCONumber", label: "ExtCONumber", maxLength: 20 },
};

const {
  coNumber,
  vendorCode,
  coDate,
  dateExpected,
  consigneeCode,
  cgCompany,
  customerCode,
  cgAddress1,
  cgAddress2,
  cgPostcode,
  cgCity,
  cgState,
  cgCountry,
  cgPhoneNo,
  cgFaxNo,
  reference,
  truckNo,
  remark,
  status,
  extCONumber,
} = formField;

// export const headerRender=[
//     [coNumber, status],
//     [extCONumber],
//     [coDate, dateExpected],
//     [{//if u want to wrap field
//         type:"fieldset",
//         label:"Consignee",
//         fieldsetRender:[
//           [consigneeCode,customerCode],
//           [cgCompany],
//           [cgAddress1],
//           [cgAddress2],
//           [cgPostcode, cgCity],
//           [cgState, cgCountry],
//           [cgPhoneNo, cgFaxNo]]
//     }],
//     [reference, truckNo],
//     [remark]
// ]

export const headerRender = [
  [coNumber,vendorCode, extCONumber, status],
  [coDate,dateExpected, reference, truckNo],
  [remark],
  [
    {
      type: "fieldset",
      label: "Consignee",
      fieldsetRender: [
        [customerCode,consigneeCode, cgCompany],
        [cgAddress1, cgAddress2, cgPostcode, cgCity],
        [cgState, cgCountry, cgPhoneNo, cgFaxNo],
      ],
    },
  ],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [coNumber.name]: Yup.string().nullable(),
  [vendorCode.name]: Yup.string().nullable().required(vendorCode.errorMsg),
  //[poDate.name]: Yup.string().nullable().required(poDate.errorMsg),
  [coDate.name]: Yup.string().nullable().required(coDate.errorMsg),
  [dateExpected.name]: Yup.string().nullable(),
  [consigneeCode.name]: Yup.string().nullable(),
  [cgCompany.name]: Yup.string().nullable().required(cgCompany.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [cgAddress1.name]: Yup.string().nullable().max(cgAddress1.maxLength),
  [cgAddress2.name]: Yup.string().nullable().max(cgAddress2.maxLength),
  [cgPostcode.name]: Yup.string().nullable().max(cgPostcode.maxLength),
  [cgCity.name]: Yup.string().nullable().max(cgCity.maxLength),
  [cgState.name]: Yup.string().nullable().max(cgState.maxLength),
  [cgCountry.name]: Yup.string().nullable().max(cgCountry.maxLength),
  [cgPhoneNo.name]: Yup.string().nullable().max(cgPhoneNo.maxLength),
  [cgFaxNo.name]: Yup.string().nullable().max(cgFaxNo.maxLength),
  [reference.name]: Yup.string().nullable().max(reference.maxLength),
  [truckNo.name]: Yup.string().nullable().max(truckNo.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
  [extCONumber.name]: Yup.string().nullable().max(extCONumber.maxLength),
});
